import { render, staticRenderFns } from "./IArrowDown.vue?vue&type=template&id=54b20351&"
import script from "./IArrowDown.vue?vue&type=script&lang=ts&"
export * from "./IArrowDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports